import axios from 'axios'
import Cookies from 'js-cookie'

import config from '@/config'
import { ERROR_MESSAGE_AUTHENTICATION, REFERRAL_SOURCE_BLANK } from '@/constants'
import { getHashedTrackingData } from '@/helpers/get-hashed-tracking-data'
import { ENDPOINTS } from '@/store/endpoints'
import { receiveProfile } from '@/store/profile'

import { handleRequestError } from './request'

const AUTHENTICATE = 'AUTHENTICATE'

export const authenticate = (data) => (dispatch) => {
    dispatch({ type: AUTHENTICATE, data })

    const extraCookieData = {
        referralSource: Cookies.get('referralSource') ?? REFERRAL_SOURCE_BLANK,
        variant: Cookies.get('variant'),
        languagePreference: Cookies.get('languagePreference') ?? 'ES',
        marketingData: {
            initialTier: Cookies.get('initialTier'),
            utmCampaign: Cookies.get('utmCampaign'),
            utmContent: Cookies.get('utmContent'),
            utmMedium: Cookies.get('utmMedium'),
            utmSource: Cookies.get('utmSource'),
            utmTerm: Cookies.get('utmTerm'),
        },
    }

    const profileData = {
        ...data,
        ...extraCookieData,
    }

    const cookiesToClear = [
        'initialTier',
        'languagePreference',
        'referralSource',
        'utmCampaign',
        'utmContent',
        'utmMedium',
        'utmSource',
        'utmTerm',
        'variant',
    ]

    return axios
        .post(ENDPOINTS.PROFILE.AUTHENTICATE, profileData)
        .then(async (response) => {
            const profile = response.data
            const { email } = profile

            const isSignUp = response.status === 201

            const { hashedEmail } = await getHashedTrackingData({ email })

            cookiesToClear.forEach((cookie) => {
                Cookies.remove(cookie, {
                    path: '/',
                    domain: config.cookieDomain,
                    secure: true,
                })
            })

            dispatch(receiveProfile(profile))

            return { profile, isSignUp, extraCookieData, hashedEmail }
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_AUTHENTICATION }))

            return Promise.reject(error)
        })
}
